<template>
    <button class="whiteBtn" :name="name" v-on:click="onClick" :disabled="disabled">
        {{ text }}
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ButtonWhite',
    props: {
        text: { type: String, required: true },
        onClick: { type: Function, required: true },
        name: { type: String, required: false },
        disabled: { type: Boolean, required: false },
        startTour: { type: Boolean, required: false },
    },
    mounted() {
        if(this.startTour){
            this.$emit('starttour');
        }
    },
    watch: {
        startTour(newValue, oldValue) {
            if (newValue === true && oldValue === false) {
                this.$emit('starttour');
            }
        }
    }
});
</script>

<style scoped>
.whiteBtn {
    background-color: var(--white);
    border: 1px solid var(--color-principal);
    color: var(--color-principal);
}
</style>
